import { render, staticRenderFns } from "./Blindbox2.vue?vue&type=template&id=ed8076a8&scoped=true&lang=pug"
import script from "./Blindbox2.vue?vue&type=script&lang=js"
export * from "./Blindbox2.vue?vue&type=script&lang=js"
import style0 from "./Blindbox2.vue?vue&type=style&index=0&id=ed8076a8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8076a8",
  null
  
)

export default component.exports